import { auth as firebaseAuth } from "../../init";
import { signOut as signOutUser } from "firebase/auth";

export const signOut = async (callback?: () => void) => {
  await signOutUser(firebaseAuth).then(() => callback && callback());
};
